(function () {

	angular.module('qbePortal').controller('QBCrossSell', QBCrossSell);

	QBCrossSell.$inject = ['$scope', '$sce'];

	function QBCrossSell($scope, $sce) {
		var vm = this;

		vm.$onInit = function () {
			vm.obj = JSON.parse(vm.content);

			for (var i = 0; i < vm.obj.length; i++) {
				if (vm.obj[i].subheading != '' || vm.obj[i].description != '' || vm.obj[i].ctaLabel != '' || vm.obj[i].hyperlinkLabel != '' || vm.obj[i].image != '') {
					vm.hasContent = true;
					break;
				}
			}
		}

		vm.getRichText = function (text) {
			return $sce.trustAsHtml(text);
		}
	}

	angular.module('qbePortal').component('qbCrossSell', {
		templateUrl: '../ngviews/components/qbCrossSell.html',
		controller: QBCrossSell,
		controllerAs: 'vm',
		bindings: {
			heading: '@',
			content: '@'
		}
	});

})();
